import { faPlusCircle, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, FieldArray, Formik, useFormikContext } from "formik";
import { get, isEmpty } from "lodash-es";
import React, { useState } from "react";
import AceEditor from "react-ace";
import { Form, Button } from "react-bootstrap";
import {
  CollectionOption,
  collectionStringToJson,
  ConditionCategory,
  filterCondition,
  FilterConditionCategory,
  standardOrAdvanced,
  usDateFormat,
} from "../../utils";
import DatePicker from "../DatePicker";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  FieldInputNumber,
} from "../Forms";
import SearchableList from "../SearchableList";
import SliderPanel from "../SliderPanel";
import PreviewSectionForFilterCondition from "./../../containers/Mapper/MapAndTransformOutput/PreviewSectionForFilterConditions";
import FieldInputDecimal from "./../Forms/FieldInputDecimal/FieldInputDecimal";

const SourceCollectionsFilter = ({
  showSlider,
  setShowSlider,
  collectionName,
  propertyName,
  sliderState,
  setSliderState,
  index,
  fieldName,
}) => {
  const {
    values: valuesMain,
    setFieldValue: setFieldValueMain,
  } = useFormikContext();

  const positionOption = [
    { label: 1 },
    { label: 2 },
    { label: 3 },
    { label: 4 },
    { label: 5 },
    { label: 6 },
    { label: 7 },
    { label: 8 },
    { label: 9 },
    { label: 10 },
  ];

  const filterString = get(valuesMain, `${fieldName}.filterString`, null);
  // const filterString = `Collection(/EmployeeClassifications,/ClassificationName,1,All[(/startDate,17,'Sun Jul 31 2022 00:00:00 GMT+0530 (India Standard Time)','Wed Dec 21 2022 00:00:00 GMT+0530 (India Standard Time)')])`;

  const savedValues = collectionStringToJson(filterString, collectionName);
  const initialValues = {
    standardOrAdvanced:
      savedValues?.standardOrAdvanced != null
        ? parseInt(savedValues?.standardOrAdvanced)
        : 1,
    filterCondition: savedValues?.filterCondition ?? "All",
    fieldOperations: savedValues?.fieldOperations ?? [
      {
        collectionCategory: null,
        operationCategory: null,
        conditionCategory: null,
        isDropDown: false,
      },
    ],
  };

  const [editorConsoleCode, setEditorConsoleCode] = useState("");
  const onSubmit = (values) => {
    var val = values.fieldOperations;
    let arr = {};
    arr = val.map((item, ind) => {
      let selectedValue = FilterConditionCategory[collectionName].filter(
        (it) => it.value == item.collectionCategory
      );
      return {
        ...arr,
        ["index"]: `${item.operationCategory ?? ""}`,
        ["object"]: !isEmpty(selectedValue)
          ? `(/${selectedValue[0]?.propertyName ?? ""}${
              item.conditionCategory
                ? `,${
                    item.isDropDown
                      ? item.dataType == "decimal"
                        ? `/${parseFloat(item.conditionCategory).toFixed(2)}`
                        : `/${item.conditionCategory}`
                      : item.dataType == "decimal"
                      ? `'${parseFloat(item.conditionCategory).toFixed(2)}'`
                      : `'${item.conditionCategory}'`
                  }`
                : ""
            }${
              item.secondaryConditionCategory
                ? `,'${parseFloat(item.secondaryConditionCategory).toFixed(2)}'`
                : ""
            })`
          : "",
      };
    });
    var convertToSingleObject = {};
    for (var i = 0, len = arr.length; i < len; i++) {
      convertToSingleObject[arr[i].index] = arr[i].object;
    }
    var stringifyFilterCollection = JSON.stringify(arr);
    stringifyFilterCollection = stringifyFilterCollection.replace(
      /"index":/g,
      ""
    );
    stringifyFilterCollection = stringifyFilterCollection.replace(
      /,"object":/g,
      ""
    );
    stringifyFilterCollection = stringifyFilterCollection.replace(/"/g, "");
    stringifyFilterCollection = stringifyFilterCollection.replace(/{/g, "");
    stringifyFilterCollection = stringifyFilterCollection.replace(/}/g, "");
    // var SingleObjectToString = JSON.stringify(convertToSingleObject);
    // var stringifyFilterCollection = SingleObjectToString.replace(/"/g, "");
    // stringifyFilterCollection = stringifyFilterCollection.replace(/:/g, "");
    // stringifyFilterCollection = stringifyFilterCollection.replace(
    //   /(\):\()/g,
    //   ","
    // );
    stringifyFilterCollection = stringifyFilterCollection.replace("[", "(");
    stringifyFilterCollection = stringifyFilterCollection.replace("]", ")");
    var collectionFunction = `Collection(${collectionName ?? ""},${
      propertyName ?? ""
    },${values.filterCondition ?? ""}`;
    stringifyFilterCollection = collectionFunction.concat(
      stringifyFilterCollection,
      ")"
    );
    var dataEditorConsoleCode = collectionFunction.concat(
      `(${editorConsoleCode})`,
      ")"
    );
    if (values.standardOrAdvanced == 1) {
      setFieldValueMain(fieldName, {
        ...get(valuesMain, fieldName, {}),
        filterString: stringifyFilterCollection,
        isCollectionParent: false,
      });
    } else if (values.standardOrAdvanced == 2) {
      setFieldValueMain(fieldName, {
        ...get(valuesMain, fieldName, {}),
        filterString: dataEditorConsoleCode,
        isCollectionParent: false,
      });
    }
    setShowSlider(false);
  };
  const onClose = () => {
    setFieldValueMain(fieldName, {
      ...get(valuesMain, fieldName, {}),
      isCollectionParent: false,
    });
    setShowSlider(false);
  };
  return (
    <Formik
      initialValues={{ ...initialValues }}
      enableReinitialize
      // onSubmit={onFormSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        values,
        setValues,
        ...rest
      }) => {
        const onValueChange = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={rest.submitCount > 0}
          >
            <SliderPanel isOpen={showSlider} size="75" showCancel={false}>
              <div className="SourceCollectionHeader source-flex mb-3">
                <div className="mt-2 planTitle">
                  {collectionName} Collections
                </div>
                <div>
                  <Button variant="secondary" onClick={() => onClose()}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => onSubmit(values)}
                    className="ml-4"
                  >
                    Save
                  </Button>
                </div>
              </div>
              <div className="border-line-seperator mb-3" />
              <div className="filter-condition">
                <div className="p-2 SourceCollectionHeader mb-3">
                  <div className="mt-2 planTitle">Filter Condition</div>
                </div>
                <div className="ml-2 mb-3">
                  <Field
                    isRequired
                    size="xs"
                    name={"standardOrAdvanced"}
                    label={"Editor"}
                    options={standardOrAdvanced}
                    selectedValue={values["standardOrAdvanced"]}
                    value={values["standardOrAdvanced"]}
                    onChange={(value) => {
                      setFieldValue("standardOrAdvanced", value);
                    }}
                    component={FieldButtonGroup}
                  />
                </div>
                {values["standardOrAdvanced"] == 1 ? (
                  <div
                    style={{
                      minHeight: "500px",
                      maxHeight: "500px",
                      overflowY: "auto",
                      paddingBottom: "60px",
                    }}
                  >
                    <div className="source-flex-around mt-3">
                      <div className="filter-condition-text mr-2">If</div>
                      <div>
                        <Field
                          size={"sm"}
                          name={"filterCondition"}
                          options={filterCondition}
                          placeholder={"All"}
                          isRequired
                          direction={"bottom"}
                          value={values["filterCondition"]}
                          popupContent={
                            <SearchableList
                              isNotTypeAhead
                              label="Click here to add"
                              name={"filterCondition"}
                              selectedValue={values["filterCondition"]}
                              onSelect={(e, label) => {
                                setFieldValue("filterCondition", label);
                              }}
                              options={filterCondition}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    <div style={{ marginLeft: "60px" }} className="mb-4">
                      <ul className="sourceCollectiontree">
                        <FieldArray name="fieldOperations">
                          {(arrayhelpers) => (
                            <>
                              {values["fieldOperations"].map((e, index) => {
                                var filterParam = ConditionCategory.filter(
                                  (_) => _.value == e.operationCategory
                                );
                                return (
                                  <li className="listSourceCollectiontree">
                                    <div className="source-flex-around">
                                      {/* first field */}
                                      <div className="pr-4">
                                        <Field
                                          size={"md"}
                                          name={`fieldOperations[${index}].collectionCategory`}
                                          isRequired
                                          direction={"bottom"}
                                          value={get(
                                            values,
                                            `fieldOperations[${index}].collectionCategory`,
                                            null
                                          )}
                                          options={
                                            FilterConditionCategory[
                                              collectionName
                                            ]
                                          }
                                          popupContent={
                                            <SearchableList
                                              isNotTypeAhead
                                              label="Click here to add"
                                              name={`fieldOperations[${index}].collectionCategory`}
                                              selectedValue={get(
                                                values,
                                                `fieldOperations[${index}].collectionCategory`,
                                                null
                                              )}
                                              onSelect={(value, label) => {
                                                let selectedValue = FilterConditionCategory[
                                                  collectionName
                                                ].filter(
                                                  (it) => it.value == value
                                                );
                                                setFieldValue(
                                                  `fieldOperations[${index}].collectionOption`,
                                                  selectedValue[0].propertyName
                                                );
                                                setFieldValue(
                                                  `fieldOperations[${index}].dataType`,
                                                  selectedValue[0].dataType
                                                );
                                                setFieldValue(
                                                  `fieldOperations[${index}].isDropDown`,
                                                  selectedValue[0].isDropDown
                                                );
                                                setFieldValue(
                                                  `fieldOperations[${index}].collectionCategory`,
                                                  value
                                                );
                                              }}
                                              options={
                                                FilterConditionCategory[
                                                  collectionName
                                                ]
                                              }
                                            />
                                          }
                                          onChange={handleChange}
                                          component={FieldDropSide}
                                        />
                                      </div>

                                      {/* second field */}
                                      <div className="pr-2 pl-4">
                                        <Field
                                          size={"sm"}
                                          name={`fieldOperations[${index}].operationCategory`}
                                          isRequired
                                          direction={"bottom"}
                                          value={get(
                                            values,
                                            `fieldOperations[${index}].operationCategory`,
                                            null
                                          )}
                                          options={ConditionCategory}
                                          popupContent={
                                            <SearchableList
                                              label="Click here to add"
                                              isNotTypeAhead
                                              name={`fieldOperations[${index}].operationCategory`}
                                              selectedValue={get(
                                                values,
                                                `fieldOperations[${index}].operationCategory`,
                                                null
                                              )}
                                              onSelect={(value, label) => {
                                                setFieldValue(
                                                  `fieldOperations[${index}].conditionCategory`,
                                                  ""
                                                );
                                                setFieldValue(
                                                  `fieldOperations[${index}].operationCategory`,
                                                  value
                                                );
                                              }}
                                              options={ConditionCategory.filter(
                                                (item) =>
                                                  item.dataType.includes(
                                                    e.dataType
                                                  )
                                              )}
                                            />
                                          }
                                          onChange={handleChange}
                                          component={FieldDropSide}
                                        />
                                      </div>
                                      {filterParam[0]?.parameters?.map((_) => (
                                        <div className="pr-2 pl-2">
                                          {filterParam[0].value ==
                                          "Position" ? (
                                            <Field
                                              size={"sm"}
                                              name={`fieldOperations[${index}].${_.name}`}
                                              isRequired
                                              direction={"bottom"}
                                              value={get(
                                                values,
                                                `fieldOperations[${index}].${_.name}`,
                                                null
                                              )}
                                              options={positionOption}
                                              popupContent={
                                                <SearchableList
                                                  isNotTypeAhead
                                                  label="Click here to add"
                                                  name={`fieldOperations[${index}].${_.name}`}
                                                  selectedValue={
                                                    values[
                                                      `fieldOperations[${index}].${_.name}`
                                                    ]
                                                  }
                                                  onSelect={(e, label) => {
                                                    setFieldValue(
                                                      `fieldOperations[${index}].${_.name}`,
                                                      label
                                                    );
                                                  }}
                                                  options={positionOption}
                                                />
                                              }
                                              onChange={handleChange}
                                              component={FieldDropSide}
                                            />
                                          ) : e.isDropDown ? (
                                            <Field
                                              size={"sm"}
                                              name={`fieldOperations[${index}].${_.name}`}
                                              isRequired
                                              direction={"bottom"}
                                              value={get(
                                                values,
                                                `fieldOperations[${index}].${_.name}`,
                                                null
                                              )}
                                              options={
                                                CollectionOption[
                                                  e.collectionOption
                                                ]
                                              }
                                              popupContent={
                                                <SearchableList
                                                  isNotTypeAhead
                                                  label="Click here to add"
                                                  name={`fieldOperations[${index}].${_.name}`}
                                                  selectedValue={
                                                    values[
                                                      `fieldOperations[${index}].${_.name}`
                                                    ]
                                                  }
                                                  onSelect={(e, label) => {
                                                    setFieldValue(
                                                      `fieldOperations[${index}].${_.name}`,
                                                      e
                                                    );
                                                  }}
                                                  options={
                                                    CollectionOption[
                                                      e.collectionOption
                                                    ]
                                                  }
                                                />
                                              }
                                              onChange={handleChange}
                                              component={FieldDropSide}
                                            />
                                          ) : e.dataType == "integer" ? (
                                            <Field
                                              size="sm"
                                              isNotTypeAhead
                                              isRequired
                                              type={"text"}
                                              name={`fieldOperations[${index}].${_.name}`}
                                              value={get(
                                                values,
                                                `fieldOperations[${index}].${_.name}`,
                                                null
                                              )}
                                              onChange={(event) =>
                                                onValueChange(
                                                  `fieldOperations[${index}].${_.name}`,
                                                  event.target.value
                                                )
                                              }
                                              component={FieldInputNumber}
                                            />
                                          ) : e.dataType == "decimal" ? (
                                            <Field
                                              size="sm"
                                              isNotTypeAhead
                                              isRequired
                                              type={"text"}
                                              name={`fieldOperations[${index}].${_.name}`}
                                              value={get(
                                                values,
                                                `fieldOperations[${index}].${_.name}`,
                                                null
                                              )}
                                              onChange={(event) => {
                                                setFieldValue(
                                                  `fieldOperations[${index}].${_.name}`,
                                                  event.target.value
                                                );
                                              }}
                                              component={FieldInputDecimal}
                                              max={99999999999.99}
                                            />
                                          ) : e.dataType == "date" ? (
                                            <Field
                                              size="sm"
                                              isRequired
                                              isNotTypeAhead
                                              name={`fieldOperations[${index}].${_.name}`}
                                              value={usDateFormat(
                                                get(
                                                  values,
                                                  `fieldOperations[${index}].${_.name}`,
                                                  null
                                                )
                                              )}
                                              isDatePicker
                                              placeholder="From date"
                                              direction="bottom"
                                              onClear={() =>
                                                onValueChange(
                                                  `fieldOperations[${index}].${_.name}`,
                                                  ""
                                                )
                                              }
                                              popupContent={
                                                <DatePicker
                                                  onDayClick={(value) =>
                                                    onValueChange(
                                                      `fieldOperations[${index}].${_.name}`,
                                                      value
                                                    )
                                                  }
                                                  value={usDateFormat(
                                                    get(
                                                      values,
                                                      `fieldOperations[${index}].${_.name}`,
                                                      null
                                                    )
                                                  )}
                                                />
                                              }
                                              component={FieldDropSide}
                                            />
                                          ) : (
                                            <Field
                                              size={"sm"}
                                              isNotTypeAhead
                                              name={`fieldOperations[${index}].${_.name}`}
                                              isRequired
                                              value={get(
                                                values,
                                                `fieldOperations[${index}].${_.name}`,
                                                null
                                              )}
                                              onChange={handleChange}
                                              component={FieldInput}
                                            />
                                          )}
                                        </div>
                                      ))}
                                      {e.conditionCategory == "Other" && (
                                        <Field
                                          size={"sm"}
                                          isNotTypeAhead
                                          name={`fieldOperations[${index}].secondaryConditionCategory`}
                                          isRequired
                                          value={get(
                                            values,
                                            `fieldOperations[${index}].secondaryConditionCategory`,
                                            null
                                          )}
                                          onChange={handleChange}
                                          component={FieldInput}
                                        />
                                      )}

                                      {values["filterCondition"] != "Not" && (
                                        <div className="pl-4">
                                          <FontAwesomeIcon
                                            icon={faTrashAlt}
                                            color="#FF0000"
                                            size={"lg"}
                                            style={{ cursor: "default" }}
                                            onClick={() =>
                                              arrayhelpers.remove(index)
                                            }
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </li>
                                );
                              })}
                              {values["filterCondition"] != "Not" && (
                                <li className="listSourceCollectiontree">
                                  <FontAwesomeIcon
                                    onClick={() => {
                                      arrayhelpers.push({
                                        collectionCategory: "",
                                        operationCategory: "",
                                        conditionCategory: "",
                                      });
                                    }}
                                    className="ml-3 mt-1"
                                    icon={faPlusCircle}
                                    size="2x"
                                  />
                                </li>
                              )}
                            </>
                          )}
                        </FieldArray>
                      </ul>
                      {/* <div>
                          <PreviewSectionForFilterCondition
                            valuesMain={valuesMain}
                            standard={true}
                            // stringifyFilterCollection={stringifyFilterCollection}
                          ></PreviewSectionForFilterCondition>
                        </div> */}
                    </div>
                  </div>
                ) : (
                  <div className="form-group">
                    <label
                      for="codeTextArea"
                      style={{ fontSize: "14px", color: "gray" }}
                    >
                      Code{" "}
                      <span>
                        <i className="far fa-question-circle"></i>
                      </span>{" "}
                    </label>

                    <AceEditor
                      style={{
                        width: "100%",
                        height: "25.25rem",
                        marginBottom: "100px",
                      }}
                      id="codeTextArea"
                      mode="csharp"
                      theme="terminal"
                      onChange={(val) => {
                        setEditorConsoleCode(val);
                      }}
                      name="UNIQUE_ID_OF_DIV"
                      editorProps={{ $blockScrolling: true }}
                      showPrintMargin={true}
                      showGutter={true}
                      highlightActiveLine={true}
                      value={editorConsoleCode}
                      setOptions={{
                        enableBasicAutocompletion: true,
                        enableLiveAutocompletion: true,
                        enableSnippets: true,
                        showLineNumbers: true,
                        tabSize: 2,
                      }}
                    />

                    <PreviewSectionForFilterCondition
                      editorConsoleCode={editorConsoleCode}
                    ></PreviewSectionForFilterCondition>
                  </div>
                )}
              </div>
            </SliderPanel>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SourceCollectionsFilter;
